// BrandTrax Listing model based on Java Listing class
export interface BrandTraxListing {
  _id?: string;
  url: string;
  domain?: string;
  title: string;
  body?: string;
  brand: string;
  product?: string;
  productCategory?: string;
  analysisProfile?: 'PRODUCT' | 'BRAND_IP_MERCHANDISE';
  channel?: Channel;
  platform?: string;
  condition?: string;
  country?: Country;
  seller: string;
  sellerStoreUrl?: string;
  createdBy?: string;
  reviewedBy?: string;
  listingStatus?: ListingStatus;
  state?: ListingState;
  distributionReason?: string;
  itemNumber?: string;
  relatedItems?: string[];
  price?: number;
  stock?: number;
  listedPrice?: number;
  numberSold?: number;
  listedCurrency?: string;
  toi?: InfringementType;
  created?: string; // ISO string
  updated?: string; // ISO string
  reviewDate?: string; // ISO string
  complaintFiledDate?: string; // ISO string
  takedownDate?: string; // ISO string
  reason?: InfringementReason;
  images?: string[];
  ipr?: string;
  score?: number;
  imageScore?: number;
  textScore?: number;
  priceScore?: number;
  risk?: Risk;
  productSize?: number;
  productSizeUnit?: string;
  imageScores?: ImageScore[];
  source?: Source;
  screenshots?: Screenshot[];
  comments?: Comment[];
  testPurchase?: string;
  _class?: string;
  reconcileUntil?: string; // ISO string
  searchScore?: number;
  tags?: string[];
}

export enum Channel {
  WEBSITE = 'WEBSITE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  MARKETPLACE = 'MARKETPLACE',
  MOBILE_APP = 'MOBILE_APP',
  META = 'META',
  NFT = 'NFT',
}

export enum Country {
  UNKNOWN = 'UNKNOWN',
  US = 'US',
  CA = 'CA',
  GB = 'GB',
  DE = 'DE',
  FR = 'FR',
  IT = 'IT',
  ES = 'ES',
  NL = 'NL',
  BE = 'BE',
  AT = 'AT',
  CH = 'CH',
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  IE = 'IE',
  PT = 'PT',
  GR = 'GR',
  LU = 'LU',
  MT = 'MT',
  CY = 'CY',
  EE = 'EE',
  LV = 'LV',
  LT = 'LT',
  SK = 'SK',
  SI = 'SI',
  HU = 'HU',
  CZ = 'CZ',
  PL = 'PL',
  RO = 'RO',
  BG = 'BG',
  HR = 'HR',
  AU = 'AU',
  NZ = 'NZ',
  JP = 'JP',
  KR = 'KR',
  CN = 'CN',
  HK = 'HK',
  SG = 'SG',
  MY = 'MY',
  TH = 'TH',
  ID = 'ID',
  PH = 'PH',
  VN = 'VN',
  IN = 'IN',
  PK = 'PK',
  BD = 'BD',
  LK = 'LK',
  NP = 'NP',
  BT = 'BT',
  MV = 'MV',
  AF = 'AF',
  IR = 'IR',
  IQ = 'IQ',
  IL = 'IL',
  JO = 'JO',
  LB = 'LB',
  SY = 'SY',
  TR = 'TR',
  SA = 'SA',
  AE = 'AE',
  QA = 'QA',
  BH = 'BH',
  KW = 'KW',
  OM = 'OM',
  YE = 'YE',
  BR = 'BR',
  AR = 'AR',
  CL = 'CL',
  CO = 'CO',
  PE = 'PE',
  VE = 'VE',
  UY = 'UY',
  PY = 'PY',
  BO = 'BO',
  EC = 'EC',
  GY = 'GY',
  SR = 'SR',
  GF = 'GF',
  MX = 'MX',
  GT = 'GT',
  BZ = 'BZ',
  SV = 'SV',
  HN = 'HN',
  NI = 'NI',
  CR = 'CR',
  PA = 'PA',
  CU = 'CU',
  JM = 'JM',
  HT = 'HT',
  DO = 'DO',
  PR = 'PR',
  TT = 'TT',
  BB = 'BB',
  AG = 'AG',
  DM = 'DM',
  GD = 'GD',
  KN = 'KN',
  LC = 'LC',
  VC = 'VC',
  RU = 'RU',
  UA = 'UA',
  BY = 'BY',
  MD = 'MD',
  GE = 'GE',
  AM = 'AM',
  AZ = 'AZ',
  KZ = 'KZ',
  UZ = 'UZ',
  TM = 'TM',
  TJ = 'TJ',
  KG = 'KG',
  MN = 'MN',
  ZA = 'ZA',
  EG = 'EG',
  LY = 'LY',
  TN = 'TN',
  DZ = 'DZ',
  MA = 'MA',
  SD = 'SD',
  SS = 'SS',
  ET = 'ET',
  ER = 'ER',
  DJ = 'DJ',
  SO = 'SO',
  KE = 'KE',
  UG = 'UG',
  TZ = 'TZ',
  RW = 'RW',
  BI = 'BI',
  MW = 'MW',
  ZM = 'ZM',
  ZW = 'ZW',
  BW = 'BW',
  SZ = 'SZ',
  LS = 'LS',
  MG = 'MG',
  MU = 'MU',
  SC = 'SC',
  KM = 'KM',
  YT = 'YT',
  RE = 'RE',
  MZ = 'MZ',
  AO = 'AO',
  CD = 'CD',
  CG = 'CG',
  CM = 'CM',
  CF = 'CF',
  TD = 'TD',
  NE = 'NE',
  NG = 'NG',
  BJ = 'BJ',
  TG = 'TG',
  BF = 'BF',
  CI = 'CI',
  GH = 'GH',
  GN = 'GN',
  GW = 'GW',
  LR = 'LR',
  SL = 'SL',
  SN = 'SN',
  GM = 'GM',
  ML = 'ML',
  MR = 'MR',
  CV = 'CV',
  ST = 'ST',
  GQ = 'GQ',
  GA = 'GA',
}

export enum ListingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  VIOLATION_REMOVED = 'VIOLATION_REMOVED',
  DELISTED = 'DELISTED',
}

export enum ListingState {
  NEW = 'NEW',
  INFRINGING = 'INFRINGING',
  IRRELEVANT = 'IRRELEVANT',
  SUSPECT = 'SUSPECT',
  AUTHORIZED_SELLER = 'AUTHORIZED_SELLER',
  LOOKALIKE = 'LOOKALIKE',
  REVIEWED = 'REVIEWED',
  REINSTATED = 'REINSTATED',
  GENUINE = 'GENUINE',
  DRAFT = 'DRAFT',
  SELLER_HOLD = 'SELLER_HOLD',
  ON_HOLD = 'ON_HOLD',
  UNAUTHORIZED_DISTRIBUTION = 'UNAUTHORIZED_DISTRIBUTION',
}

export enum InfringementType {
  CR = 'CR', // Copyright
  TM = 'TM', // Trademark
  DE = 'DE', // Design
  CFT = 'CFT', // Counterfeit
  CS = 'CS', // Cybersquatting — deprecated for new listings; retained for legacy data
}

export enum InfringementReason {
  UNAUTHORIZED_MARK = 'UNAUTHORIZED_MARK',
  UNAUTHORIZED_LOGO = 'UNAUTHORIZED_LOGO',
  UNAUTHORIZED_DEVICE = 'UNAUTHORIZED_DEVICE',
  REG_COPYRIGHT_MATCH = 'REG_COPYRIGHT_MATCH',
  COPYRIGHT_MATCH = 'COPYRIGHT_MATCH',
  LOGO_CHARACTER_MATCH = 'LOGO_CHARACTER_MATCH',
  PACK_SHOT_IMAGE = 'PACK_SHOT_IMAGE',
  CREATIVE_VISUAL_IMAGE = 'CREATIVE_VISUAL_IMAGE',
  DESIGN_INFRINGEMENT = 'DESIGN_INFRINGEMENT',
  UTILITY_INFRINGEMENT = 'UTILITY_INFRINGEMENT',
  NO_RISK = 'NO_RISK',
  GREY_MARKET = 'GREY_MARKET',
  SAMPLE_SALE = 'SAMPLE_SALE',
  TESTER_SALE = 'TESTER_SALE',
  POLICY_VIOLATION = 'POLICY_VIOLATION',
  REGULATORY_VIOLATION = 'REGULATORY_VIOLATION',
  SUSPECT = 'SUSPECT',
  SELECTIVE_INTEGRATED_DISTRIBUTION = 'SELECTIVE_INTEGRATED_DISTRIBUTION',
  EXPIRED_PRODUCT = 'EXPIRED_PRODUCT',
  SOLD_WITHOUT_PRESCRIPTION = 'SOLD_WITHOUT_PRESCRIPTION',
  COUNTERFEIT = 'COUNTERFEIT',
  CUSTOMIZED_SAMPLES = 'CUSTOMIZED_SAMPLES',
  CONCEALED_TRADEMARK = 'CONCEALED_TRADEMARK',
  LOW_PRICE_PRODUCT = 'LOW_PRICE_PRODUCT',
  ODD_VOLUME_SIZE = 'ODD_VOLUME_SIZE',
  PRODUCT_NOT_MANUFACTURED = 'PRODUCT_NOT_MANUFACTURED',
  NOT_FOR_SALE_SAMPLE = 'NOT_FOR_SALE_SAMPLE',
  HIGH_RISK_KEYWORDS = 'HIGH_RISK_KEYWORDS',
  VARIATION_IN_TRADE_DRESS = 'VARIATION_IN_TRADE_DRESS',
  FAKE_TESTERS = 'FAKE_TESTERS',
  FAKE_OR_MISLEADING_APP = 'FAKE_OR_MISLEADING_APP',
}

export enum Risk {
  LOW = 'LOW',
  MED = 'MED',
  HIGH = 'HIGH',
}

export enum Source {
  C = 'C', // Chrome extension
  X = 'X', // Excel
  P = 'P', // Programmatic
}

export interface ImageScore {
  // Define based on actual ImageScore model if needed
  [key: string]: any;
}

export interface Screenshot {
  image: string;
  timestamp?: string;
}

export interface Comment {
  // Define based on actual Comment model if needed
  [key: string]: any;
}
